// @ts-nocheck
import React from "react";
import { Route } from "react-router";
import { Switch } from "react-router";
import LoginPage from "./pages/LoginPage";
import VerifyPage from "./pages/VerifyPage";
import RegisterPage from "./pages/RegisterPage";
import ActivatePage from "./pages/ActivatePage";
import { Routes } from "../../constants/routes";
import VerifyProfilePage from "./pages/VerifyProfilePage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RegisterAgentPage from "./pages/RegisterAgentPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import RegisterStudentPage from "./pages/RegisterStudentPage";
import RegisterTeacherPage from "./pages/RegisterTeacherPage";
import AuthRoute from "./components/routes/AuthRoute";
import GuestRoute from "./components/routes/GuestRoute";
import RegisterSchoolPage from "./pages/RegisterSchoolPage";
import RegisterParentPage from "./pages/RegisterParentPage";
import RegisterServiceProviderPage from "./pages/RegisterServiceProviderPage";
import TemporaryPage from "../pages/TemporaryPage";
import VerifySchool from "./pages/VerifySchool";
import { UserRole } from "../user/enums/UserRole";

export default function Auth({ path }: { path: string }) {
  return (
    <Route path={path}>
      <Switch>
        <GuestRoute
          exact
          component={LoginPage}
          path={`${path}${Routes.LOGIN}`}
        />
        <GuestRoute
          exact
          component={RegisterPage}
          path={`${path}${Routes.REGISTER}`}
        />
        <GuestRoute
          exact
          component={RegisterStudentPage}
          path={`${path}${Routes.REGISTER_STUDENT}`}
        />
        <GuestRoute
          exact
          component={RegisterParentPage}
          path={`${path}${Routes.REGISTER_PARENT}`}
        />
        <GuestRoute
          exact
          component={RegisterTeacherPage}
          path={`${path}${Routes.REGISTER_TEACHER}`}
        />
        <GuestRoute
          exact
          component={RegisterAgentPage}
          path={`${path}${Routes.REGISTER_AGENT}`}
        />
        <GuestRoute
          exact
          component={RegisterSchoolPage}
          path={`${path}${Routes.REGISTER_SCHOOL}`}
        />
        <GuestRoute
          exact
          component={RegisterServiceProviderPage}
          path={`${path}${Routes.REGISTER_SERVICE_PROVIDER}`}
        />
        <AuthRoute
          exact
          component={VerifyPage}
          verified={false}
          profileVerified={null}
          path={`${path}${Routes.VERIFY}`}
        />
        <AuthRoute
          exact
          component={VerifySchool}
          roles={[UserRole.School]}
          path={`${path}${Routes.VERIFY_SCHOOL}`}
        />
        <AuthRoute
          exact
          component={TemporaryPage}
          temporary={true}
          hideHeaderItems={true}
          path={`${path}${Routes.TEMPORARY_PAGE}`}
        />
        <Route
          exact
          component={ActivatePage}
          path={`${path}${Routes.ACTIVATE}`}
        />
        <AuthRoute
          exact
          roles={[UserRole.Agent, UserRole.School, UserRole.ServiceProvider]}
          component={VerifyProfilePage}
          profileVerified={false}
          path={`${path}${Routes.PROFILE_VERIFY}`}
        />
        <GuestRoute
          exact
          component={ForgotPasswordPage}
          path={`${path}${Routes.FORGOT_PASSWORD}`}
        />
        <GuestRoute
          exact
          component={ResetPasswordPage}
          path={`${path}${Routes.RESET_PASSWORD}`}
        />
      </Switch>
    </Route>
  );
}
